import { useEffect } from "react"

import { useInstitucionalPublico } from "./useInstitucionalPublico"

/**
 * Ajusta o título da aba do navegador com a sigla/nome do órgão cadastrados
 * (dados institucionais públicos), evitando um título estático no `index.html`.
 */
export function useTituloInstitucional() {
  const { data } = useInstitucionalPublico()

  useEffect(() => {
    const nome = data?.nomeEmpresa?.trim()
    const sigla = data?.sigla?.trim()
    if (!nome && !sigla) return
    document.title = `${sigla || nome} · SIGI`
  }, [data])
}
